import type { RestrictionEventAction } from 'contracts/restricted-products/restricted-products';

export const RESTRICTION_EVENTS_NAME_MAP: Record<RestrictionEventAction, string> = {
  block: 'Boqueio',
  unblock: 'Desbloqueio',
  updateQuantity: 'Atualização de quantidade',
  saleMovement: 'Movimento de venda',
};